import React from 'react';
import googleplaybtn from '../../assets/images/google_play_btn.png';

const PlayStoreBtn = () => {

  return (
    <>
        <a
        href="https://play.google.com/store/apps/details?id=com.salesgro_mobileapp"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
        >
        <img
            src={googleplaybtn}
            alt="Get it on Google Play"
            style={{
            height: '60px',
            width: 'auto',
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
        />
        </a>
    </>
  );
};

export default PlayStoreBtn;